/**
 * LinkedIn Insight Tag ids (#2445).
 *
 * The partner id and the three conversion ids come from the build-time
 * env (`REACT_APP_LINKEDIN_*`, read once in `ux/src/config.js`). They are
 * read only through getLinkedInInsightIds(). An unset partner id turns the
 * whole tag off; an unset conversion id turns that one conversion off.
 */

import config from '../config';

export const LINKEDIN_INSIGHT_SCRIPT_SRC = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';

function cleanId(value) {
  const text = typeof value === 'string' ? value.trim() : '';
  return /^\d+$/.test(text) ? text : '';
}

/**
 * @returns {{ partnerId: string, conversionIds: { SIGNUP: string, STORE_CLICK: string, CHECKOUT: string } }}
 * Empty strings mean "not configured".
 */
export function getLinkedInInsightIds() {
  const env = config.LINKEDIN || {};
  return {
    partnerId: cleanId(env.PARTNER_ID),
    conversionIds: {
      SIGNUP: cleanId(env.CONV_SIGNUP),
      STORE_CLICK: cleanId(env.CONV_STORE_CLICK),
      CHECKOUT: cleanId(env.CONV_CHECKOUT),
    },
  };
}

export function isLinkedInInsightConfigured() {
  return getLinkedInInsightIds().partnerId !== '';
}
